import React, { useState, useEffect } from "react";
import Select from "react-select";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { getCountryList } from "./_redux/Crud";
import SVG from "react-inlinesvg";

const CountrySelectInput = (props) => {
  const [allCountries, setAllCountries] = useState([]);
  const [country, setCountry] = useState(null);

  const customStyles = {
    control: (base, state) => ({
      ...base,
      "&:hover": {
        borderColor: state.isFocused ? "red" : "transparent",
      },
    }),
  };

  const getCountryListAPICall = async () => {
    if (localStorage?.getItem("token")) {
      try {
        let temp = [];
        let response = await getCountryList();
        if (response) {
          temp.push({
            name: "All Countries dsgdfh",
            svg: 'true',
            _id: "all"
          });
          response.data.map((item) => {
            temp.push(item);
          });
          setAllCountries(temp);
        }
      } catch (error) {
        // Handle error if needed
      }
    } else {
      window.location.reload();
    }
  };

  const updateCountry = (e) => {
    setCountry(e);
    localStorage.setItem("country", JSON.stringify(e));
    localStorage.setItem("countryname", e.name);
    window.location.reload();
  };

  const handleMenuOpen = () => {
    getCountryListAPICall();
  };

  useEffect(() => {
    // Load the initial country data from localStorage
    const storedCountry = JSON.parse(localStorage.getItem("country"));
    if (storedCountry) {
      setCountry(storedCountry);
    }
  }, []);

  return (
    <Select
      placeholder="Select Country"
      value={country}
      options={allCountries}
      onChange={updateCountry}
      onMenuOpen={handleMenuOpen}
      styles={customStyles}
      getOptionValue={(option) => option.name}
      getOptionLabel={(e) => (
        <div style={{ display: "flex", alignItems: "center", backgroundColor: "transparent" }}>
          {e?.svg ? (
            <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Flag.svg")} />
          ) : (
            <img 
              // src={e.flag ? `${process.env.REACT_APP_UPLOADED_FILE_URL}/${e.flag.default}` : ""} alt="Flag" 
              height={25} width={30} 
            />
          )}
          <span style={{ marginLeft: 5 }}>{e.name}</span>
        </div>
      )}
    />
  );
};

export default CountrySelectInput;
